import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ProfilesByType } from './pages/ProfilesByType/ProfilesByType';
import { NewRisk } from './pages/NewRisk/NewRisk';
import { FormRisk } from './pages/FormRisk/FormRisk';
import { SummaryRisk } from './pages/SummaryRisk/SummaryRisk';
import { usePDF } from 'react-to-pdf';
import { useReactToPrint } from 'react-to-print';

const getMode = (path: string) => {
	const pathArray = path.split('/');
	return pathArray[2];
};

export const useJobProfile = () => {
	const location = useLocation();
	const mode = getMode(location.pathname);

	const { toPDF, targetRef } = usePDF({
		filename: 'welbe-job-profile-summary.pdf',
		overrides: {
			canvas: {
				useCORS: true,
			},
		},
	});
	const handlePrint = useReactToPrint({
		content: () => targetRef?.current || null,
	});

	const handleDownload = () => {
		if (targetRef) {
			toPDF();
		}
	};

	const onAction = (action: 'download' | 'print') => {
		if (action === 'print') {
			setTimeout(() => {
				handlePrint();
			}, 50);
		}

		if (action === 'download') {
			setTimeout(() => {
				handleDownload();
			}, 100);
		}
	};

	const ComponentViewer = useMemo(() => {
		if (mode === 'profile') {
			return NewRisk;
		}

		if (mode === 'risk-factors') {
			return FormRisk;
		}

		if (mode === 'summary') {
			return SummaryRisk;
		}

		return ProfilesByType;
	}, [mode]);

	return {
		targetRef,
		onAction,
		ComponentViewer,
	};
};
